module.exports = __webpack_public_path__ + "static/eit-food-eu-logo-f1d121c3e721723774caff2089b5cb15.png";